/* eslint-disable no-undef */
import { waitForElm, onReady } from "/Assets/js/utilities.js";
export default class Recaptcha {
    init() {
        onReady(() => {
            var submit = document.querySelector("[data-editorblocktype=SubmitButtonBlock]");

            if (submit) {
                var newNode = document.createElement("div");
                newNode.id = "d365turnstile";
                submit.parentNode.insertBefore(newNode, submit);
            }

            waitForElm("#d365turnstile").then((element) => {
                try {
                    this.renderTurnstile(element);
                } catch {
                    try {
                        this.renderTurnstile(element);
                    } catch (err) {
                        this.showErrorMessage();
                    }
                }
            });
        });
    }

    hideErrorMessage() {
        var recaptchaElement = document.getElementById("d365turnstile");
        var errorEl = recaptchaElement.querySelector(".Form__Element__ValidationError");
        if (errorEl) {
            errorEl.remove();
        }
    }

    showErrorMessage() {
        var recaptchaElement = document.getElementById("d365turnstile");

        let errorEl;
        let prevErrorEl = recaptchaElement.querySelector(".Form__Element__ValidationError");
        if (prevErrorEl !== null) {
            errorEl = prevErrorEl;
        } else {
            errorEl = document.createElement("span");
            errorEl.className = "Form__Element__ValidationError";
            errorEl.textContent = "Unable to verify";
        }

        if (recaptcha) {
            recaptchaElement.appendChild(errorEl);
        }
    }

    renderTurnstile(element) {
        const self = this;

        try {
            window.turnstile?.ready(() => {
                turnstile.render(element, {
                    sitekey: "0x4AAAAAAA0Vkt3b96lzLme5",
                    theme: "light",
                    action: self.getFormName()
                });
            });
        } catch (err) {
            self.showErrorMessage();
        }
    }

    getFormName() {
        var element = document.querySelector("[data-embedded-form-block-name]");
        return element.getAttribute("data-embedded-form-block-name");
    }
}
